module.exports = __webpack_public_path__ + "static/media/22.036ec4a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/22.svg
// module id = 2814
// module chunks = 3